<script lang="ts" setup>
import { GpAlert } from '@gportal/uikit';
import { BillingPeriod } from 'gpcore-grpc/gpcore/api/cloud/v1/billing_pb';

withDefaults(
  defineProps<{
    period: BillingPeriod;
    paidUntil: Date;
  }>(),
  {
    period: BillingPeriod.UNSPECIFIED,
    paidUntil: () => new Date(),
  },
);
</script>

<template>
  <GpAlert
    v-if="period !== BillingPeriod.UNSPECIFIED && paidUntil.getTime() > new Date().getTime()"
    :alert-type="period === BillingPeriod.DELETED ? 'danger' : 'info'"
    role="alert"
  >
    <strong>Notice!</strong>
    <span v-if="period === BillingPeriod.MONTHLY">
      This node will be changed to monthly billing after {{ paidUntil.toUTCString() }}.
    </span>
    <span v-if="period === BillingPeriod.HOURLY">
      This node will be changed to hourly billing after {{ paidUntil.toUTCString() }}.
    </span>
    <span v-if="period === BillingPeriod.DELETED">
      This node will get deleted after {{ paidUntil.toUTCString() }}.
    </span>
  </GpAlert>
</template>
